import React from 'react';
import PropTypes from 'prop-types';
import './ActivityItem.css';

function ActivityItem({ 
  type = 'event', // 'event', 'organizer', 'dataChange', 'report'
  dateTime, 
  title, 
  onClick 
}) {
  // Color mapping based on type
  const colorMap = {
    event: '#EE8F3B',      // Orange
    organizer: '#7D959F',  // Teal/Morski-light
    dataChange: '#201E25', // Dark
    report: '#DD2626',     // Red
  };

  const indicatorColor = colorMap[type] || colorMap.event;

  return (
    <div className="activity-item" onClick={onClick}>
      <div 
        className="activity-item__indicator" 
        style={{ backgroundColor: indicatorColor }}
      />
      <div className="activity-item__content">
        <span className="activity-item__datetime">{dateTime}</span>
        <span className="activity-item__title">{title}</span>
      </div>
      <div className="activity-item__arrow">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.91 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.91 4.08" stroke="#7E7E7E" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
}

ActivityItem.propTypes = {
  type: PropTypes.oneOf(['event', 'organizer', 'dataChange', 'report']),
  dateTime: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

ActivityItem.defaultProps = {
  type: 'event',
  onClick: () => {},
};

export default ActivityItem;

